import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from '../../common/react-redux-hooks';
// import IconFolderClose from '../ACShared/IconFolderClose';
// import DefinitionFolderMenu from './AutocodeMenu/DefinitionFolderMenu';
import ACDefinitionFolderItem from './ACDefinitionFolderItem';
import ACDefinitionFolderDeleteModal from './ACDefinitionFolderDeleteModal';
import AddNewButton from '../../../images/Autocode/definitionAddNewButton.svg';
import { useACProjectContext } from '../ACContext/ACDefinitionContext';
import {
  createNewDefinition,
  patchTargetFolder,
  deleteDefinition,
  deleteSharedDefinition,
} from '../../../actions/definitionActions';
import {
  AC_PERSONAL_FOLDER_SCOPE,
  AC_SHARED_FOLDER_SCOPE,
} from '../AutocodeConstants';
import { useACEditContext } from '../ACContext/ACEditContext';
import { CO1_DEF_DELETE, COMPOSER_SUBMODULE } from '../../../trackerConstants';
import { saveTrackingData } from '../../../util/trackerUtils';

const ACDefinitionFolder = ({
  title,
  folders,
  onLeafNodeClicked,
  selectedFolder,
  setselectedFolder,
  canAddNewFolders,
  folderHeight,
}) => {
  const [folderList, setFolderList] = useState(folders);
  const [folderToDelete, setFolderToDelete] = useState(null);
  useEffect(() => setFolderList(folders), [folders]);

  const { moduleStudy, activeAccountId, uid, menuName } = useACProjectContext();
  const { showDefFolderEllipsis } = useACEditContext();
  const dispatch = useDispatch();

  const addNewFolder = () => {
    const request = {
      token: '',
      ssid: moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      accountId: activeAccountId,
      productNo: moduleStudy.pn,
      thisStudy: false,
      folderName: 'New Folder',
      shared: false,
      newExpressions: [],
      sort: 'defSort=sc-a,ct-d',
    };
    dispatch(createNewDefinition(request));
  };

  const saveFolderName = folder => {
    const request = {
      token: '',
      ssid: moduleStudy.ss === 'SIMMONS' ? 1 : 2,
      accountId: activeAccountId,
      productNo: moduleStudy.pn,
      definitionId: folder.definitionId,
      folderName: folder.folderName,
    };
    dispatch(patchTargetFolder(request));
  };

  const deleteFolder = folder => {
    const token = '';
    const ssid = moduleStudy.ss === 'SIMMONS' ? 1 : 2;
    const accountId = activeAccountId;
    const productNo = moduleStudy.pn;
    const definitionId = folder.definitionId;
    if (
      folder.scope === AC_PERSONAL_FOLDER_SCOPE.value1 ||
      folder.scope === AC_PERSONAL_FOLDER_SCOPE.value2
    ) {
      dispatch(
        deleteDefinition(token, ssid, accountId, productNo, definitionId)
      );
    } else if (
      folder.scope === AC_SHARED_FOLDER_SCOPE.value1 ||
      folder.scope === AC_SHARED_FOLDER_SCOPE.value2
    ) {
      dispatch(
        deleteSharedDefinition(token, ssid, accountId, productNo, definitionId)
      );
    }
    saveTrackingData({
      uid,
      accid: activeAccountId,
      productNo,
      moduleName: menuName,
      subModule: COMPOSER_SUBMODULE,
      action: CO1_DEF_DELETE,
    });
    setselectedFolder({});
  };

  const keyHandler = event => {
    if (
      (event.key === 'Delete' &&
        selectedFolder.selectedFolder.scope ===
          AC_PERSONAL_FOLDER_SCOPE.value1) ||
      selectedFolder.selectedFolder.scope === AC_PERSONAL_FOLDER_SCOPE.value2
    ) {
      setFolderToDelete(selectedFolder.selectedFolder);
    }
  };

  return (
    <div
      className="ac--def__folder-card"
      data-test="ACDefinationFolder"
      style={{ height: `${folderHeight}px` }}
    >
      <div className="ac--def__folder-header">
        <h4>
          {title}
          {canAddNewFolders && (
            <img
              className="pull-right"
              src={AddNewButton}
              alt="add new"
              title="Add New Folder"
              onClick={addNewFolder}
              style={{ cursor: 'pointer', paddingRight: '8px' }}
            />
          )}
        </h4>
      </div>
      <div className="ac--def__folder-body">
        <div className="ac--def__folder-list" onKeyDown={keyHandler}>
          {folderList.length > 0 ? (
            folderList.map(item => (
              <ACDefinitionFolderItem
                key={item.definitionId}
                folder={item}
                selectedFolder={selectedFolder}
                onSave={saveFolderName}
                onDelete={setFolderToDelete}
                canEdit={canAddNewFolders} // folders only editable if group can add new ones
                onLeafNodeClicked={onLeafNodeClicked}
                showDefFolderEllipsis={showDefFolderEllipsis}
              />
            ))
          ) : (
            <div className="ac--def__folder-list--empty">No folders</div>
          )}
        </div>
      </div>
      {folderToDelete && (
        <ACDefinitionFolderDeleteModal
          folder={folderToDelete}
          show={folderToDelete !== null}
          closeHandler={() => setFolderToDelete(null)}
          deleteHandler={() => {
            deleteFolder(folderToDelete);
            setFolderToDelete(null);
          }}
        />
      )}
    </div>
  );
};

ACDefinitionFolder.propTypes = {
  folderHeight: PropTypes.number,
  title: PropTypes.string.isRequired,
  folders: PropTypes.instanceOf(Array),
  onLeafNodeClicked: PropTypes.func,
  canAddNewFolders: PropTypes.bool,
  selectedFolder: PropTypes.shape({
    selectedFolder: {
      scope: PropTypes.number,
    },
  }),
  setselectedFolder: PropTypes.func,
};

export default ACDefinitionFolder;
